module.exports = __webpack_public_path__ + "img/info.d88da840.png";